import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from "@angular/core";
import { TransactionService } from "../shared/services/transaction.service";
import { AdminService } from "../shared/services/admin.service";
import { AgentService } from "../shared/services/agent.service";
import { environment } from "../../environments/environment";
import { DailyDollarRateService } from "../shared/services/dailydollarrate.service";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { TopbarComponent } from "../shared/components/topbar/topbar.component";
import { SidebarComponent } from "../shared/components/sidebar/sidebar.component";
import { BottombarComponent } from "../shared/components/bottombar/bottombar.component";
import { StatComponent } from "./stat/stat.component";
import { GraphComponent } from "./graph/graph.component";
import { PieComponent } from "./pie/pie.component";

@Component({
    selector: "app-dashboard",
    templateUrl: "./dashboard.component.html",
    styleUrls: ["./dashboard.component.css"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        RouterModule,
        TopbarComponent,
        SidebarComponent,
        BottombarComponent,
        StatComponent,
        GraphComponent,
        PieComponent,
    ]
})
export class DashboardComponent implements OnInit {
  data = {};
  allIMTOBalance;
  agents;
  details;
  config;
  balance;
  permission;
  partnerCommissionInPayInCurrency;
  partnerCommissionInSettlement;
  exchangeRate;
  greeting = "Welcome";
  todayLabel = "";

  get canSeeBalance(): boolean {
    return (
      !!this.details &&
      (this.details.permission === "admin" ||
        this.details.permission === "super_admin")
    );
  }

  get isSuperAdmin(): boolean {
    return !!this.details && this.details.permission === "super_admin";
  }

  constructor(
    private transactionService: TransactionService,
    private adminService: AdminService,
    private agentService: AgentService,
    private dailyDollarRateService: DailyDollarRateService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    const hour = new Date().getHours();
    this.greeting =
      hour < 12 ? "Good morning" : hour < 16 ? "Good afternoon" : "Good evening";
    this.todayLabel = new Date().toLocaleDateString("en-GB", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    this.getDetails();
    this.getAll();
    this.getExchangeRate();
  }


  getDetails() {
    // this.transactionService.getDetails().subscribe(
    //   data => {
    //     this.details = data[0];
    //   }
    // );
this.adminService.getDetails().subscribe((data) => {
      console.log('this is new', data)

      if(data[0] === undefined){
         this.details = data.original.data[0]
      }else {
     this.details = data[0];

      }
     
      this.permission = this.details.permission;
      this.refresh();
      this.transactionService
        .statistics(this.details.permission, this.details.agent.id)
        .subscribe((data) => {
          this.data = data;
          this.refresh();
        });
      this.transactionService
        .getBalance(this.details.agent.slug)
        .subscribe((data) => {
          this.balance = data.balance;
          this.partnerCommissionInPayInCurrency =
            data.partnerCommissionInPayInCurrency;
          this.partnerCommissionInSettlement =
            data.partnerCommissionInSettlement;
          this.refresh();
        });
    });
  }

  refresh() {
    try {
      this.cdr.detectChanges();
    } catch (e) { void e; }
  }

  getAll() {
    if (environment.production) {
      this.agentService.get().subscribe((data) => {
        console.log("this agent", data);
        const initialValue = 0;
        this.agents = data;
        this.allIMTOBalance = data.reduce((accumulator, currentValue) => {
          console.log("this is current value", currentValue);
        if (currentValue.status === "1") {
        return accumulator + Number(currentValue.balance || 0);
        }
         return accumulator;
}, initialValue);
        this.refresh();

        // console.log("this agent balance", this.allIMTOBalance);
        // this.config = {
        //   itemsPerPage: 10,
        //   currentPage: 1,
        //   totalItems: data.length
        // };
      });
    } else {
      this.agentService.getTest().subscribe((data) => {
        console.log("this agent", data);
        const initialValue = 0;
        this.agents = data;
this.allIMTOBalance = data.reduce((accumulator, currentValue) => {
        return accumulator + Number(currentValue.balance || 0);
        }, initialValue);
        this.refresh();
        // this.config = {
        //   itemsPerPage: 10,
        //   currentPage: 1,
        //   totalItems: data.length
        // };
      });
    }
  }

  getExchangeRate() {
    this.dailyDollarRateService.getCurrentRate().subscribe((data) => {
      this.exchangeRate = data
      this.refresh();
    });
  }
}
